/*
 * @Author: hujie striveyf@dingtalk.com
 * @Date: 2023-06-22 11:37:55
 * @LastEditors: hujie striveyf@dingtalk.com
 * @LastEditTime: 2023-06-24 10:25:36
 * @FilePath: \vysa_wifi_web\src\request\index.ts
 * @Description: axios
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import axios from "axios";

import { closeToast, showLoadingToast } from "vant";
import router from '@/router'
import store from "@/store";
let loadingCount = 0;

class Request {
  instance: any;
  constructor() {
    this.instance = axios.create({
      baseURL: process.env.VUE_APP_PROXY_PATH + process.env.VUE_APP_BASE_PATH,
      timeout: 10000,
    });
    
    this.instance.interceptors.request.use((config: any) => {
      loadingCount++;
      if (loadingCount > 0) {
        showLoadingToast({
          duration: 0,
          message: "加载中...",
          forbidClick: true,
          loadingType: "spinner",
        });
      }
      config.headers.tenant = store.state.tenantId || sessionStorage.getItem("tenantId");
      return config;
    }, (error: any) => {
      return Promise.reject(error)
    })

    this.instance.interceptors.response.use((response: any) => {
      loadingCount--;
      if (loadingCount <= 0) {
        closeToast();
      }
      if (response.status == 200) {
        return response.data
      } else {
        return Promise.reject(response.data);
      }
    }, ((err: any) => {
      loadingCount--;
      if (loadingCount <= 0) {
        closeToast();
      }
    }))
  }

  get(url: string, params?: any) {
    return this.instance.get(url, {
      params
    })
  }

  post(url: string, data?: any, params?: any) {
    return this.instance.post(url,
      data,
      params
    )
  }

  put(url: string, data?: any) {
    return this.instance.put(url, {
      data
    })
  }

  delete(url: string, params?: any) {
    return this.instance.delete(url, {
      params
    })
  }
};

export const https = new Request();
